// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3H1ea","item":"PaymentsMobile_item__3-911","label":"PaymentsMobile_label__2h0Sz","amount":"PaymentsMobile_amount__1bm3L"};